<template>
  <div class="slide bg-cover bg-center" :style="style">
    <div v-if="overlay" class="overlay"></div>
    <slot></slot>
  </div>
</template>
<script>
import Path from '../../mixins/Path.vue';
export default {
  mixins: [Path],
  props: {
    overlay: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    style() {
      return "background-image: url('" + this.path + "');";
    },
  },
};
</script>
